// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__B1Clt","content":"LoadingAlert_content__2AVk2"};